/** Appends broker vendorType/login to contact URL for new-car broker flows (vendorType === "1"). */
export function appendBrokerUrlParams(
  urlString: string,
  pageType: string,
  vendorType?: string | null,
  login?: string | null
): string {
  if (pageType !== "new" || vendorType != "1" || !login) {
    return urlString;
  }

  const params = new URLSearchParams(urlString);
  params.set("vendorType", "1");
  params.set("login", login);
  return params.toString();
}
